import { PlayerPortalsPageTemplate } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsPageTemplate,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.PageTemplate) =>
    kontentAiDataMapping.player_portals_page_template(entry),
};
